import React from 'react';
import PropTypes from 'prop-types';

function ArsenalCard({ meal }) {
    return (
        <div className="card-meal" key={meal.id}>
            <p className="meal-title">{meal.name}</p>
            <p className="description">{meal.description} </p>

            <div className="all-prices">
                <div>
                    <div className="name-price">Étudiant UNamur</div>
                    <div className="price">{meal.unamur_student_price}€</div>
                </div>
                <div>
                    <div className="name-price">Étudiant externe</div>
                    <div className="price">{meal.external_student_price}€</div>
                </div>
                <div>
                    <div className="name-price">Personnel UNamur</div>
                    <div className="price">{meal.unamur_staff_price}€</div>
                </div>
                <div>
                    <div className="name-price">Personne externe</div>
                    <div className="price">{meal.external_price}€</div>
                </div>
            </div>

            <p className="allergen">
                Allergènes :
                {meal.allergens && meal.allergens.length > 0
                    ? ` ${meal.allergens.map((allg) => allg.name).join(', ')}`
                    : ' /'}
            </p>
        </div>
    );
}

ArsenalCard.propTypes = {
    meal: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string,
        allergens: PropTypes.arrayOf(
            PropTypes.shape({
                number: PropTypes.string.isRequired,
            })
        ),
        external_student_price: PropTypes.string.isRequired,
        external_price: PropTypes.string.isRequired,
        unamur_student_price: PropTypes.string.isRequired,
        unamur_staff_price: PropTypes.string.isRequired,
    }).isRequired,
};

export default ArsenalCard;
